import React, { FC } from 'react'
import ReactTooltip from 'react-tooltip'
import MarkdownContent from 'components/common/atoms/MarkdownContent'
import { css } from '@emotion/core'
import { useTheme } from 'emotion-theming'

type TooltipProps = {
  id: string
  place: 'bottom' | 'top' | 'right' | 'left'
  className?: string
}

const tooltipStyle = () => css`
  .tooltip {
    width: 200px;
    padding: 16px;
    opacity: unset !important;
    border-radius: 4px;
    &__text {
      p,
      li {
        font-size: 12px;
        line-height: 18px;
        margin-bottom: 0;
        color: #fff;
        white-space: pre-line;
      }
    }
  }
`

const Tooltip: FC<TooltipProps> = ({ id, place = 'bottom', className = '' }) => {
  const theme: ThemeType = useTheme()
  return (
    <span css={tooltipStyle}>
      <ReactTooltip
        id={id}
        aria-haspopup="true"
        backgroundColor={theme.gray.gray60}
        borderColor={theme.gray.gray60}
        arrowColor={theme.gray.gray60}
        effect="solid"
        place={place}
        className={`tooltip ${className}`}
        getContent={(dataTip: string) => (
          <div>
            <MarkdownContent content={dataTip} className="tooltip__text" />
          </div>
        )}
      />
    </span>
  )
}

export default Tooltip
